/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { withRouter } from 'react-router-dom';
import RegistrationInfo from '../../../components/Registration/redesign/Components/registrationInfo';
import * as Actions from '../actions';
import taggingSaga from '../../Common/Tagging.js/sagas';
import * as taggingActions from '../../Common/Tagging.js/actions';
import injectSaga from '../../../utils/injectSaga';
import cartSaga from '../../../services/Cart/sagas';
import * as cartActions from '../../../services/Cart/actions';

const mapStateToProps = (state) => {
  // const cartDetails = state.cartDetails || {};
  const registrationDetails =
    state.cartDetails && state.cartDetails.cartDetailsJson && state.cartDetails.cartDetailsJson.registrationDetails
      ? state.cartDetails.cartDetailsJson.registrationDetails
      : {};
  const currentView = state.currentView || {};
  const apiStatus = state?.cartDetails?.apiStatus;
  const { isUniversalProfileCreated } = state?.contactInfo;
  const isCradleFlow = state?.contactInfo?.isCradleSuccess;
  const isEmailExists =
    state.contactInfo?.emailAPiResponse?.amValidationResponse?.emailAddressAsUserId === 'true' ||
    ((state.contactInfo?.emailAPiResponse?.valid === 'Valid' || state.contactInfo?.emailAPiResponse?.valid === 'White_listed') &&
      !state.contactInfo?.emailAPiResponse?.amValidationResponse);
  return {
    registrationDetails,
    currentView,
    isUniversalProfileCreated,
    isEmailExists,
    apiStatus,
    isCradleFlow,
  };
};
const mapDispatchToProps = (dispatch) => bindActionCreators({ ...Actions, ...cartActions, ...taggingActions }, dispatch);

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withSaga = compose(
  injectSaga({ key: 'cartDetails', saga: cartSaga }),
  injectSaga({ key: 'taggingDetails', saga: taggingSaga }),
);

export default withRouter(
  compose(
    withSaga,
    withConnect,
  )(RegistrationInfo),
);
